import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axiosSetUp from './interceptor/axios'

import "bootstrap/dist/css/bootstrap.min.css"

axiosSetUp();

createApp(App)
    .use(router)
    .use(store)
    .mount('#app')

